import type { IconShortcutProps } from '@/components_deprecated'
import { IconShortcut, ShortcutsWrapper } from '@/components_deprecated'
import { useTranslate } from '@ur-solutions/react-hooks'
import styled from 'styled-components'

const Wrapper = styled.section`
  max-width: 100%;
`

interface DashboardLinksProps {
  links: IconShortcutProps[]
}

export const DashboardLinks: React.FC<DashboardLinksProps> = ({ links }) => {
  const translations = useTranslate({
    handbook: 'common.drivers-handbook',
  })
  return (
    <Wrapper>
      <h2>{translations.handbook}</h2>
      <ShortcutsWrapper>
        {links.map(link => (
          <IconShortcut key={link.text} {...link} />
        ))}
      </ShortcutsWrapper>
    </Wrapper>
  )
}
